// extracted by mini-css-extract-plugin
export default {"wrapper":"MenuTitleComponent_wrapper__ZCu1G","logoImage":"MenuTitleComponent_logoImage__ADkIp"};